import { Link } from 'react-router-dom'
import { LegalPageLayout } from '../components/LegalPageLayout'

export default function SupportPage() {
  return (
    <LegalPageLayout title="Support">
      <h1>Support</h1>
      <p className="legal-intro">
        gymAhead is an iPhone app for planning and tracking workouts. If you
        need help, have feedback, or want to report a problem, we are here.
      </p>

      <h2>Contact</h2>
      <p>
        Email us at{' '}
        <a href="mailto:contact@beahead.ai">contact@beahead.ai</a>. We
        typically respond within a few business days.
      </p>

      <h2>Common topics</h2>
      <ul>
        <li>Account sign-in and workout sync</li>
        <li>Workout generation and session tracking</li>
        <li>Progress and offline data on your device</li>
        <li>Bug reports and feature requests</li>
      </ul>

      <h2>Privacy</h2>
      <p>
        For how we handle your data, see our{' '}
        <Link to="/privacy">Privacy Policy</Link>.
      </p>
    </LegalPageLayout>
  )
}
